import omit from 'lodash/omit';
import { GatewayCreateFormValues } from 'pages/Gateways/GatewaysCreate/types';

import { prepareGatewayCreateSubmitValues } from './prepareGatewayCreateSubmitValues';

export const prepareGatewayBulkCreateSubmitValues = (values: GatewayCreateFormValues) =>
  omit(prepareGatewayCreateSubmitValues(values), [
    'name',
    'externalAlias',
    'autocreateMethod',
    'gatewayMethodsFromMethods',
  ]);
